import { render, staticRenderFns } from "./PreviewHeader.vue?vue&type=template&id=39764c64&scoped=true&"
import script from "./PreviewHeader.vue?vue&type=script&lang=js&"
export * from "./PreviewHeader.vue?vue&type=script&lang=js&"
import style0 from "./PreviewHeader.vue?vue&type=style&index=0&id=39764c64&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39764c64",
  null
  
)

export default component.exports